import { createApiSlice } from "@common";
import { CRUD_COMPETITOR_ANALYSIS } from "@routes";

const apiConfig = [
  {
    name: "addCompetitorAnalysis",
    method: "post",
    url: CRUD_COMPETITOR_ANALYSIS,
    stateKey: "message",
  },
  {
    name: "getCompetitorAnalysisById",
    method: "get",
    url: CRUD_COMPETITOR_ANALYSIS,
    stateKey: "data",
  },
  {
    name: "updateCompetitorAnalysis",
    method: "put",
    url: CRUD_COMPETITOR_ANALYSIS,
    stateKey: "message",
  },
  {
    name: "deleteCompetitorAnalysis",
    method: "delete",
    url: CRUD_COMPETITOR_ANALYSIS,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
    resetCompetitorAnalysisData: (state) => {
      state.data = [];
      state.additionalData = [];
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "competitorAnalysis",
  apiConfig,
  customReducers);
const competitorAnalysisSlice = slice;

export default competitorAnalysisSlice.reducer;

export const {
  addCompetitorAnalysis,
  getCompetitorAnalysisById,
  updateCompetitorAnalysis,
  deleteCompetitorAnalysis,
} = thunks;

export const { rowSelect, setAdditionalData, resetCompetitorAnalysisData } = actions;
